<div class="bottom-sheet-container">
  <div>
      <button type="button" class="close-btn" (click)="closeSheet()" aria-label="Close">
          <i class="material-icons">close</i>
      </button>

      <h1 class="header">Want to Avoid Parts Mismatch?</h1>
    </div>

    <div class="sheet-media">
        <img src="../../../../assets/images/avoidPartsMissmatch/mismatch.jpg" class="mismatch-img"
            alt="Ensure you avoid parts mismatch by choosing your car first">
        <img src="../../../../assets/images/avoidPartsMissmatch/benefits.png" class="benefits-img"
            alt="Benefits: perfect fit and save time">
    </div>

    <div class="sheet-actions">
        <button type="button" class="find-btn" (click)="navigate()">Yes, Find My Car</button>
        <button type="button" class="continue-btn" (click)="closeSheet()">Continue without car selection</button>
    </div>
</div>
